export const SAVE_HOST_DETAILS = 'SAVE_HOST_DETAILS';
export const SAVE_HOST_DETAILS_SUCCESS = 'SAVE_HOST_DETAILS_SUCCESS';
export const SAVE_HOST_DETAILS_FAILS = 'SAVE_HOST_DETAILS_FAILS';